var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstract2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 160,
    viewBox: "0 0 144 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9992 33.9911H18.001C18.001 103.581 74.4093 160 143.999 160V141.999C84.3482 141.999 35.9992 93.6421 35.9992 33.9911Z",
    fill: "#F6F7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.999 -37.9991V-56C94.2896 -56 54 -15.7104 54 33.9912C54 83.7007 94.2896 124.001 143.999 124.001V106C104.231 106 72.0009 73.7619 72.0009 33.9938C72.0009 -5.76102 104.231 -37.9991 143.999 -37.9991Z",
    fill: "#F6F7F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.999 -20.0012C114.169 -20.0012 89.999 4.16904 89.999 33.9909C89.999 63.8206 114.169 87.9988 143.999 87.9988V33.9988L197.999 33.9909C197.999 4.16904 173.831 -20.0012 143.999 -20.0012Z",
    fill: "#F6F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract2);
export default __webpack_public_path__ + "static/media/abstract-2.16739fa4deb8cf480d80d98db39e4157.svg";
export { ForwardRef as ReactComponent };